// The following length validations should be aligned with mc core
export const MAX_EMAIL_LENGTH = 254 // https://www.rfc-editor.org/errata_search.php?rfc=3696&eid=1690
export const MAX_EMAIL_LOCAL_PART_LENGTH = 64
export const MAX_PASSWORD_LENGTH = 72
export const MIN_PASSWORD_LENGTH = 4
export const MAX_NAME_LENGTH = 50
export const EMAIL_VALIDATION_PATTERN =
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
